import React from "react";

interface Props {
  readOnly: string[];
  writeFreeRequiresAuth: string[];
  paidWriteRequiresAuth: string[];
  blocked: string[];
}

function Group(props: { tone: "neutral" | "amber" | "rose" | "slate"; title: string; subtitle: string; items: string[] }): React.ReactElement {
  const tones: Record<string, string> = {
    neutral: "bg-emerald-50 border-emerald-200 text-emerald-900",
    amber: "bg-amber-50 border-amber-200 text-amber-900",
    rose: "bg-rose-50 border-rose-200 text-rose-900",
    slate: "bg-slate-50 border-slate-200 text-slate-700",
  };
  return (
    <div className={`rounded-xl border p-4 ${tones[props.tone]}`}>
      <div className="text-xs uppercase tracking-wider font-medium mb-1">{props.title}</div>
      <div className="text-xs mb-2 opacity-80">{props.subtitle}</div>
      <ul className="text-sm space-y-1.5">
        {props.items.map((it, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className="text-xs mt-0.5">•</span>
            <span>{it}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function ActionClassLegend(props: Props): React.ReactElement {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
      <Group tone="neutral" title="Read-only" subtitle="Available now; no authorization needed." items={props.readOnly} />
      <Group tone="amber" title="Write / free" subtitle="Requires explicit operator authorization." items={props.writeFreeRequiresAuth} />
      <Group tone="rose" title="Paid + write" subtitle="Requires explicit operator authorization. Costs apply." items={props.paidWriteRequiresAuth} />
      <Group tone="slate" title="Blocked" subtitle="Not authorized in current state." items={props.blocked} />
    </div>
  );
}
